const ArrowLeft = () => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4152 3.33937C11.8905 3.80121 11.9014 4.56093 11.4396 5.03625L5.83916 10.8H21C21.6627 10.8 22.2 11.3373 22.2 12C22.2 12.6627 21.6627 13.2 21 13.2H5.83916L11.4396 18.9638C11.9014 19.4391 11.8905 20.1988 11.4152 20.6606C10.9399 21.1225 10.1801 21.1116 9.7183 20.6362L2.13935 12.8362C1.68687 12.3706 1.68687 11.6294 2.13935 11.1638L9.7183 3.36376C10.1801 2.88844 10.9399 2.87752 11.4152 3.33937Z"
    />
  </>
);

export default ArrowLeft;
